import type { IconName } from '@freelancer/ui/icon';
import type { QueryParams } from '@freelancer/ui/link';

export enum SplitButtonOptionPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export interface SplitButtonOption {
  displayText: string;
  newTab?: boolean; // flag to open in a new tab for desktop
  link?: string;
  linkQueryParams?: QueryParams;
  iconName?: IconName;
}
